import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://vduajlwjzbxzdkjlgnwy.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'placeholder';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

if (!process.env.REACT_APP_SUPABASE_URL) {
  console.error('CRITICAL: REACT_APP_SUPABASE_URL is missing from .env! Please restart the server.');
}


